import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { Alert, Button, Table } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as utility from '../data/Utility';
import * as sortfilter from '../data/SortFilter';

class ManageAccountsInternal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
			isShowingFilter: false,
			currentFilters: {},
			currentSortDirection: {},
			currentSortingColumn: '',
            allFetched: false
        }
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
    }

    componentDidUpdate(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAdministrator(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching, !this.state.allFetched)) {
            this.props.accountsDispatch.getAll();
            this.setState({
                allFetched: true
            });
        }
    }

    handleAccountSelected(userName) {
        const history = this.props.history;
        if (history.location.pathname === paths.manageAccounts) {
            history.push({
                pathname: paths.account,
                state: {
                    editing: false,
                    userName: userName
                }
            });
        }
    }


	toggleFilter() {
		if ( this.state.isShowingFilter ) {
			this.setState({ currentFilters: {} });
		}
		this.setState({ isShowingFilter: ! this.state.isShowingFilter });
	}

	onSortChange = (currentColumn) => {
		let currentSortDirection = this.state.currentSortDirection;
		let nextSort = 'default';

		switch ( currentSortDirection[currentColumn] ) {
			case "down": nextSort = 'default'; break;
			case "up"  : nextSort = 'down'; break;
			default    : nextSort = 'up'; break;
		}

		let newCurrentSortDirection = {};
		newCurrentSortDirection[currentColumn] = nextSort;

		this.setState({
			currentSortDirection: newCurrentSortDirection,
			currentSortingColumn: currentColumn,
		});
	};

	onFilterChange = (e) => {
		this.setState({ currentFilters: {...this.state.currentFilters, [e.target.name]: e.target.value } });
	};

	ColumnHeader = (props) => {
		sortfilter.filterAssociation[props.recordKey] = props.label;
		let val = this.state.currentFilters[props.label];
		if ( val === undefined ) {
			val = '';
		}
		return <sortfilter.ColHeader value={val} onChange={this.onFilterChange.bind(this)} sortDir={this.state.currentSortDirection} onSortChange={this.onSortChange} showFilter={this.state.isShowingFilter} label={props.label} recordKey={props.recordKey} />
	};



    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        var error = false;
        var message = "";
        var accountList = null;

        const accounts = this.props.accountsState.all;
        if (accounts != null &&
            accounts.map != null) {
            const editTitle = "Edit";
            var rowNum = 1;

            let aList = [...accounts].map(account => {
                const role = account.role;
                const allStudiesRole = (
                    Accounts.isHcsRole(role) ||
                    role === Accounts.accountRoles.Physician
                );
                var studies = "{All}";
                if (!allStudiesRole) {
                    studies = utility.getNamesFromArray(account.studies);
                }

				return ({ ...account,
					studies: studies,
					enabled: (account.enabled) ? "Enabled" : "Disabled",
				});
            });
			aList = sortfilter.filterData( aList, this.state.currentFilters );

            accountList = [...aList].sort( sortfilter.sortingDetails(this.state.currentSortingColumn,this.state.currentSortDirection).fn ).map(account => {
                return (
                    <tr key={account.id} onClick={this.handleAccountSelected.bind(this, account.userName)}>
                        <th scope="row">{rowNum++}</th>
                        <td>{account.userName}</td>
                        <td>{account.firstName}</td>
                        <td>{account.lastName}</td>
                        <td>{account.role}</td>
                        <td>{account.studies}</td>
                        <td>{account.enabled}</td>
                        <td>
                            <Button className="button-inverse" title={editTitle} tag={Link} to={{ pathname: paths.account, state: { userName: account.userName } }}>{editTitle}</Button>
                        </td>
                    </tr>
                );
            });
        }
        else {
            error = true;
            message = "Error retrieving accounts.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <div>
                <h1>Manage Accounts</h1>
                <Button className="button filter_button" id="btnFilter" title="Filter" onClick={this.toggleFilter.bind(this)}> Filter </Button>
                <br />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>#</th>
							<this.ColumnHeader label="User Name" recordKey="userName" />
							<this.ColumnHeader label="First Name" recordKey="firstName" />
							<this.ColumnHeader label="Last Name" recordKey="lastName" />
							<this.ColumnHeader label="Role" recordKey="role" />
							<this.ColumnHeader label="Studies" recordKey="studies" />
							<this.ColumnHeader label="Enabled" recordKey="enabled" />
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accountList}
                    </tbody>
                </Table>
            </div>
        );
    }
}

const ManageAccountsConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch)
    })
)(ManageAccountsInternal));

export default class ManageAccounts extends React.Component {
    render() {
        return (
            <ErrorBoundary>
                <ManageAccountsConnect />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ManageAccounts.js